import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gpv-asset-assigments',
  templateUrl: './asset-assigments.component.html',
  styleUrls: ['./asset-assigments.component.css']
})
export class AssetAssigmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
